import { em } from 'polished'
import styled from 'styled-components'

export const FormBox = styled.div`
  width: ${em(182)};
`
